export const strings = {
  en: {
    beamAttribution: () => `Powered by Beam`,
    ctaTitle: () => `Choose your impact`,
    ctaPromoPrefixMessage: () => `At no extra cost,`,
    ctaPromoMessage: ({ donationPercentage = "1" } = {}) =>
      `select a nonprofit and ${donationPercentage}% will be donated there for you.`,
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `At no extra cost, select a nonprofit and ${donationPercentage}% will be donated there for you.`,
    submitButtonText: () => `Confirm`,
    submitButtonTextCompleted: () => `Confirmed!`,
    chooseButtonText: () => `Choose a nonprofit`,
  },
  fr: {
    beamAttribution: () => `Optimisé par Beam`,
    ctaTitle: () => `Choisissez votre cause`,
    ctaPromoPrefixMessage: () => `Sans frais supplémentaires,`,
    ctaPromoMessage: ({ donationPercentage = "1" } = {}) =>
      `sélectionnez une association et ${donationPercentage} % sera reversé en votre nom.`,
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `Sans frais supplémentaires, choisissez une association et ${donationPercentage} % de votre commande lui sera reversé en votre nom.`,
    submitButtonText: () => `Confirmer`,
    submitButtonTextCompleted: () => `Confirmé !`,
    chooseButtonText: () => `Choisir une association`,
  },
  de: {
    beamAttribution: () => `Unterstützt von Beam`,
    ctaTitle: () => `Wähle deine Wirkung`,
    ctaPromoPrefixMessage: () => `Ohne zusätzliche Kosten,`,
    ctaPromoMessage: ({ donationPercentage = "1" } = {}) =>
      `wähle eine gemeinnützige Organisation und ${donationPercentage}% werden in deinem Namen gespendet.`,
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `Ohne zusätzliche Kosten kannst du eine Organisation auswählen, und ${donationPercentage}% deiner Bestellung werden gespendet.`,
    submitButtonText: () => `Bestätigen`,
    submitButtonTextCompleted: () => `Bestätigt!`,
    chooseButtonText: () => `Wähle eine Organisation`,
  },
  es: {
    beamAttribution: () => `Ofrecido por Beam`,
    ctaTitle: () => `Elige tu impacto`,
    ctaPromoPrefixMessage: () => `Sin coste adicional,`,
    ctaPromoMessage: ({ donationPercentage = "1" } = {}) =>
      `elige una organización y donaremos el ${donationPercentage}% en tu nombre.`,
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `Sin coste adicional, elige una organización sin ánimo de lucro y donaremos el ${donationPercentage}% de tu compra en tu nombre.`,
    submitButtonText: () => `Confirmar`,
    submitButtonTextCompleted: () => `¡Confirmado!`,
    chooseButtonText: () => `Elige una organización`,
  },
  it: {
    beamAttribution: () => `Promosso da Beam`,
    ctaTitle: () => `Scegli il tuo impatto`,
    ctaPromoPrefixMessage: () => `Senza costi aggiuntivi,`,
    ctaPromoMessage: ({ donationPercentage = "1" } = {}) =>
      `scegli un'organizzazione e doneremo l’${donationPercentage}% per te.`,
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `Senza costi aggiuntivi, scegli un'organizzazione no profit e doneremo l’${donationPercentage}% del tuo acquisto a suo favore.`,
    submitButtonText: () => `Conferma`,
    submitButtonTextCompleted: () => `Confermato!`,
    chooseButtonText: () => `Scegli un'organizzazione`,
  },
  pl: {
    beamAttribution: () => `Obsługiwane przez Beam`,
    ctaTitle: () => `Wybierz swój wpływ`,
    ctaPromoPrefixMessage: () => `Bez dodatkowych kosztów,`,
    ctaPromoMessage: ({ donationPercentage = "1" } = {}) =>
      `wybierz organizację, a ${donationPercentage}% zostanie przekazane w Twoim imieniu.`,
    ctaMessage: ({ donationPercentage = "1" } = {}) =>
      `Bez dodatkowych kosztów możesz wybrać organizację, której przekażemy ${donationPercentage}% wartości Twojego zamówienia w Twoim imieniu.`,
    submitButtonText: () => `Potwierdź`,
    submitButtonTextCompleted: () => `Potwierdzono!`,
    chooseButtonText: () => `Wybierz organizację`,
  },
};
